import type { AgGridColumnDef } from './AgGridTable'

export const resolveDefaultHiddenColumns = <T>(
    columns: AgGridColumnDef<T>[],
    _isKdp: boolean,
    tableName: string,
): Set<string> => {
    const hidden = new Set<string>()
    const fields = new Set(columns.map((c) => c.field as string))

    const h = (field: string) => hide(fields, hidden, field)

    columns.forEach((column) => {
        if (column.hide) h(column.field as string)
    })

    // Globals
    h('cac')
    h('aov')
    h('roas')
    h('rpc')
    h('blended_cvr')
    h('adjusted_orders')
    h('adjusted_sales')
    h('adjusted_pages_read')
    h('adjusted_estimated_royalties')
    h('blended_roas')
    h('blended_cac')
    h('blended_aov')

    switch (tableName) {
        case 'campaigns':
            h('start_date')
            h('end_date')
            h('smart_bid')
            h('last_daily_budget_change')

            break
    }

    return hidden
}

/** Add a field to the hidden set if it exists in the fields set */
const hide = (fields: Set<string>, hidden: Set<string>, field: string) => {
    if (fields.has(field)) {
        hidden.add(field)
    }
}

export const resolveDefaultPinning = <T>(
    columns: AgGridColumnDef<T>[],
    isKdp: boolean,
    _tableName: string,
): Record<string, 'start' | 'end' | false> => {
    const pinned = {}
    const fields = new Set(columns.map((c) => c.field as string))

    const p = (field: string, position: 'start' | 'end') => pin(fields, pinned, field, position)

    p('checkbox', 'start')

    if (isKdp) {
        p('blended_acos', 'end')
    } else {
        p('acos', 'end')
    }

    return pinned
}

const pin = (
    fields: Set<string>,
    pinned: Record<string, 'start' | 'end' | false>,
    field: string,
    position: 'start' | 'end',
) => {
    if (fields.has(field)) {
        pinned[field] = position
    }
}
